import numeral from 'numeral';

const NUMBER_FORMATS = {
  DEFAULT: '0,0',
  PERCENTAGE: '0,0.[0]'
};
function formatNumber(number, format = 'DEFAULT') {
  if (number === undefined) {
    return '';
  }
  return numeral(number).format(NUMBER_FORMATS[format]);
}

export { NUMBER_FORMATS, formatNumber };
